export default __webpack_public_path__ + "static/media/bike.1ab2d0a4.png";